<template>
    <div>
        <div>
            MTB Preparation
        </div>
    </div>
</template>
<script>
</script>
<style>
</style>
